import VehicleType from '@/enums/VehicleType';
import VehicleLevel from '@/enums/VehicleLevel';
import CampaignVehicleLevel from '@/enums/CampaignVehicleLevel';
import IInitialSettingsViewModel from './interfaces/IInitialSettingsViewModel';

export default class InitialSettingsViewModel implements IInitialSettingsViewModel {
  public manufacturers: number[] | null = null;

  public range: number | null = null;

  public bodystyles: string[] | null = null;

  public fuelTypes: string[] | null = null;

  public autoScroll: boolean = false;

  public vehicleType: VehicleType = VehicleType.Car;

  public vehicleLevel: VehicleLevel = VehicleLevel.Derivative;

  public thanksPageId!: number;

  public thanksEmailTemplateName!: string;

  public leadSourceGuid!: string;

  public privacyPolicyGuid!: string;

  public privacyPolicyVersionId!: string;

  public servicePolicyGuid!: string;

  public servicePolicyVersionId!: string;

  public servicePolicyVersionText!: string;

  public termsPolicyGuid!: string;

  public termsPolicyVersionId!: string;

  public marketingPolicyGuid!: string;

  public marketingPolicyVersionId!: string;

  public marketingPolicyVersionText!: string;

  public fcaPolicyGuid!: string;

  public fcaPolicyVersionId!: string;

  public partnerMarketingPolicyGuid!: string;

  public partnerMarketingPolicyVersionId!: string;

  public partnerMarketingPolicyVersionText!: string;

  public campaignVehicleLevel: CampaignVehicleLevel = CampaignVehicleLevel.None;

  public hideDerivativeOptions: boolean = false;

  public allowedManufacturerIds: number[] = [];

  public allowFullNavigation: boolean = false;

  public showErrorsOnNext: boolean = false;

  public allowedTestDriveManufacturerIds: number[] = [];

  public blockedTestDriveRangeIds: number[] = [];

  public useCapImagesRangeIds: number[] = [];

  public totalSteps: number = 0;

  public correlationId: string | null = null;

  public hideSlidersOnTouchScreens: boolean = false;

  public showExitIntentSurvey: boolean = false;

  public exitIntentSurveyDelay: number = 0;

  public exitIntentHeaderCopy!: string;

  public exitIntentPlaceholderCopy!: string;

  public exitIntentCTACopy!: string;

  public useImaginStudio: boolean = false;

  public imaginStudioZoomLevel: number = 0;

  public hideFieldsWithOneOption: boolean = false;
}
